import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';
import { apiUrl } from '../constants';

const isDev = process.env.NODE_ENV === 'development';

const restLink = new RestLink({
  uri: isDev ? apiUrl + '/api/' : '/api/',
  endpoints: {
    helper: isDev ? apiUrl + '/api/helper/' : '/api/helper/',
    api: isDev ? apiUrl + '/api/' : '/api/',
  },
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: restLink,
});

export default client;
